module.exports = __webpack_public_path__ + "static/media/dorp.69463dc3.jpg";